import { createSignal } from 'solid-js';

export interface RealtimeClick {
  user: string;
  country: string;
  city: string;
  region: string;
  ip_address: string;
  user_agent: string;
  network: string;
  traffic_source?: string;
  traffic_type?: string;
  device_type?: string;
  created_at: string;
  timestamp?: number;
}

/**
 * Global store for real-time clicks
 * Keeps only current session data (not persisted to localStorage)
 * Data is cleared on page refresh
 */
const [realtimeClicks, setRealtimeClicks] = createSignal<RealtimeClick[]>([]);

/**
 * Add a new click to the global real-time clicks store
 * Prepends to the beginning and keeps only the latest maxClicks
 */
export const addRealtimeClick = (click: RealtimeClick, maxClicks: number = 50) => {
  const newClick: RealtimeClick = {
    ...click,
    timestamp: Date.now(),
  };

  setRealtimeClicks((prevClicks) => {
    const updated = [newClick, ...prevClicks].slice(0, maxClicks);
    return updated;
  });
};

/**
 * Clear all real-time clicks
 */
export const clearRealtimeClicks = () => {
  setRealtimeClicks([]);
};

/**
 * Get the real-time clicks signal
 */
export const getRealtimeClicksSignal = () => realtimeClicks;

export default {
  addRealtimeClick,
  clearRealtimeClicks,
  getRealtimeClicksSignal,
};
